import React, { Component } from 'react';
import { Checkbox, Row, Col, Icon } from 'antd';
import { DraggableAreasGroup } from './Draggable';
import SvgIcon from 'SvgIcon';
require('./style.css')
const group = new DraggableAreasGroup();
const DraggableArea = group.addArea();

export default class DraggableAreaControl extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { dragChecked, selectedItems } = this.props;
    return (
      <div className={"square right" + (dragChecked ? ' drag-checked' : '') + (selectedItems.length == 0 ? ' nodata' : '')}>
        <DraggableArea
          onChange={tags => { this.props.changeTags(tags, this.props.index) }}
          tags={this.props.Tags}
          render={({ tag, index }) => (
            <div className={'tag ' + (!!tag.checked ? 'tag-checked' : '')} onClick={(e) => { this.props.handleTagTriggerClick(this.props.index, index, e) }}>
              {index ? <span size={'small'}>+</span> : null}
              {tag.caption}
              <SvgIcon type='shanchu2' style={{ cursor: "pointer" }} className="close-button" onClick={() => this.props.clickDelete(tag, this.props.index)} />
            </div>
          )}
        />
      </div>
    );
  }
}

;




// WEBPACK FOOTER //
// ./src/yxyweb/common/components/dimension-setting/DraggableArea.jsx